<template>
    <div id="r2s1">
        <h2 class="title main">
            {{ $t('f_r2s1_title') }}
        </h2>

        <sign-seal ref="signseal" name="poa" />

        <div class="own-input upload-wrap">
            <div>
                {{ $t('f_plane_ticket_label') }}
                <info-tip class="bottom" :text="$t('f_plane_ticket_tip_text')" />
            </div>
            <documents-form :list="tickets" name="tickets" doc_type="travel_plan">
                {{ $t('f_upload_btn') }}
            </documents-form>
        </div>

        <div class="own-input">
            <span>
                <label for="bookingNumber">{{ $t('f_booking_number_label') }}</label>
                <info-tip :text="$t('f_booking_number_tip_text')" />
            </span>
            <input
                id="bookingNumber" 
                v-model="reservation_number" 
                v-m-android-focus
                v-normalize
                type="text">
        </div>

        <div class="own-input">
            <label for="whenInformed">{{ $t('f_when_informed_label') }}</label>
            <info-tip :text="$t('f_when_informed_tip_text')" />
            <div class="select-wrap">
                <span class="icon icon-chevron-up" />
                <select
                    id="whenInformed"
                    v-model="client_informed"
                    v-validate="'required'"
                    v-m-android-focus
                    name="client_informed">
                    <option value="">
                        {{ $t('f_client_informed_placeholder') }}
                    </option>
                    <option v-for="(title, value) of informedMapper" :key="value" :value="value">
                        {{ title }}
                    </option>
                </select>
            </div>
            <span class="error-message">{{ errors.first(`client_informed`) }}</span>
        </div>

        <div v-if="false">
            <div class="hr" />

            <h2 class="title cotact-title" v-html="$t('f_contacted_label')" />

            <div v-if="$device.mobile()" class="inline-input yes-no-wrap">
                <div class="own-input">
                    <label class="checkbox-container">
                        {{ $t('f_yes') }}
                        <input
                            v-model="contacted_airline"
                            v-validate="'required'"
                            type="radio"
                            name="contacted_airline"
                            value="true">
                        <span class="checkmark" />
                    </label>
                </div>
                <div class="own-input">
                    <label class="checkbox-container">
                        {{ $t('f_no') }}
                        <input
                            v-model="contacted_airline"
                            v-validate="'required'"
                            type="radio"
                            name="contacted_airline"
                            value="false">
                        <span class="checkmark" />
                    </label>
                </div>
            </div>

            <div v-else class="inline-desktop inline-input">
                <div class="own-input">
                    <div class="check-btn">
                        <input
                            id="haveContact-yes"
                            v-model="contacted_airline"
                            v-validate="'required'"
                            type="radio"
                            name="contacted_airline"
                            value="true">
                        <label for="haveContact-yes">
                            {{ $t('f_yes') }}
                        </label>
                    </div>
                </div>
                <div class="own-input">
                    <div class="check-btn">
                        <input
                            id="haveContact-no"
                            v-model="contacted_airline"
                            v-validate="'required'"
                            type="radio"
                            name="contacted_airline"
                            value="false">
                        <label for="haveContact-no">
                            {{ $t('f_no') }}
                        </label>
                    </div>
                </div>
            </div>
            <span class="error-message">{{ errors.first(`contacted_airline`) }}</span>
        </div>

        <server-errors v-if="serversErrors" :message="serversErrors" />
        <div class="own-input next-prev-wrap thin">
            <div :class="['btn btn-orange', {'invalid': formIsInvalid(), 'progress': loading}]" @click="next">
                <span v-show="!loading">{{ $t('f_continue') }} &#10093;</span>
                <div v-if="loading" class="spinner">
                    <div class="rect1" />
                    <div class="rect2" />
                    <div class="rect3" />
                    <div class="rect4" />
                    <div class="rect5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {mapFields} from 'vuex-map-fields'
  import formNavMixin from '../mixins/formNavMixin'
  import DocumentsForm from '../common/DocumentsForm'
  import SignSeal from '../common/SignSeal'

  export default {
    components: { DocumentsForm, SignSeal },
    mixins: [formNavMixin],
    data() {
      return {
        module: 'round2',
      }
    },
    computed: {
      ...mapGetters({
        informedMapper: 'round2/informedMapper',
        tickets: 'documents/tickets'
      }),

      ...mapFields([
        'round2.complaint.client_informed',
        'round2.complaint.contacted_airline',
        'signseal.poa.activated'
      ]),

      reservation_number: {
        get: function() {
          return this.$store.state.round2.complaint.reservation_number
        },
        set: function(newVal) {
          let correctValue = newVal.toUpperCase()
          this.$store.commit('round2/UPDATE_COMPLAINT_FIELD', {
              path: 'reservation_number',
              value: correctValue
          })
        }
      },
    },
    methods: {
      next(){
        this.formSubmittion({scope: `*`, formSelector: '#r2s1'}).then(({success, fail}) => {
          if (this.activated){ this.$refs.signseal.submit() }
          this.$store.dispatch("round2/putAuthorization", this.$store.getters['round2/r2s1FormData']).then(()=> {
            this.$store.commit('round2/NEXT_STEP')
            success()
          }).catch((response) => {
            fail(response)
          })
        })
      }
    }
  }
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  #r2s1 {
    .upload-wrap {
      .content {
        top: auto;
      }
    }

    .flight-booking-number-wrap{
      margin-bottom: 10px;

      .flight-booking-number {
        .own-input{
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .error-message{
            position: absolute;
          }
        }
      }
    }

    .hr {
      width: 150%;
      margin-top: 35px;
      margin-left: -100px;
      border: 1px solid #eaeef3;

      html.tablet &, html.desktop & {
        width: 100%;
        margin-left: 0;
      }
    }

    .cotact-title {
      position: relative;
      font-size: 18px;

      .icon-thin-info {
        font-size: 18px;
      }

      .content {
        bottom: 32px;
      }
    }
  }
</style>
